<template>
  <CustomDialog
    append-to-body
    :visi.sync="visi"
    width="700px"
    title="扫码联系我们">
    <div slot="content" class="content">
      <p class="tip">
        <span>
          <svg-icon icon-class="wechat" />
          微信扫一扫
        </span>
      </p>
      <img src="/static/img/contact_qrcode.jpg" />
    </div>
    <div slot="footer">
      <el-button
        type="success"
        size="small"
        plain
        @click="visi = false">
        关闭
      </el-button>
    </div>
  </CustomDialog>
</template>

<script>
export default {
  data () {
    return {
      visi: false
    }
  },
  methods: {
    show(){
      this.visi = true
    }
  }
}
</script>

<style lang="scss" scoped>
.content{
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 400px;
  .tip{
    font-size: 24px;
    color: $text1;
    margin-bottom: 40px;
    .svg-icon{
      color: $theme-color;
    }
  }
  img{
    width: 200px;
    height: 200px;
    padding: 10px;
    border: 1px solid #eee;
    box-shadow: 1px 1px 2px rgba(0,0,0,.3);
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/Navbar/WechatQrCode.vue